import React, { useState, useEffect } from "react";
import ScreenHeading from "../../Utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../Utilities/ScrollService";
import Animations from "../../Utilities/Animations";
import "./Projects.css";

import JavaWebApp from "../../../src/img/Projects/JavaWebApp.PNG";
import PhpWebApp from "../../../src/img/Projects/PhpWebApp.PNG";
import shape from "../../../src/img/Testimonial/shape-bg.png";

import dockerIcon from "../../../src/img/MyIcons/docker-icon1.png"

export default function AboutMe(props) {
    let fadeInScreenHandler = (screen) => {
      if (screen.fadeInScreen !== props.id) return;
      Animations.animations.fadeInScreen(props.id);
    };
  
    const fadeInSubscription =
      ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

      return (
        <div
          className="projects-container screen-container fade-in"
          id={props.id || ""}
        >
          <div className="projects-parent">
              <ScreenHeading
                  title={"Projects"}
                  subHeading={"My Role In Projects I Have Worked On (As a Group and Individually)."}
              />
              <div className="projects-content">
                <div className="project">
                  <span className="project-title">
                    <h5>CI/CD Pipeline For <u>Java WebApp</u> Deployment.</h5>
                    <h6>(Click image to go to project)</h6>
                  </span>
                  <div className="project-img">
                    <a href="https://www.inlineofsight.net/">
                      <img
                        src={JavaWebApp}
                        alt="Failed to load"
                      />
                    </a>
                  </div>
                   <div className="project-details">
                    <div className="project-description">
                       <div className="project-description-h6">
                        Software Configuration management
                        </div>
                      
                      <br />
                      <span className="project-description-text">
                        <div className="text-styling-1">
                        <div>&emsp;- &ensp; &ensp;</div>
                        <div>Automate CI & CD pipeline using Ansible, Nexus, Sonarqube, Maven, Jenkins
                        Terraform and GIT.</div>
                        </div>
                      </span>
                      <br />
                      <span className="project-description-text">

                      <div className="text-styling-2">
                        <div>&emsp;- &ensp; &ensp;</div>
                        <div>Automating AWS cloud deployments using Shell script, Jenkins. Writing inventory and manifest<br />
                        files, and ansible playbooks. Containerized deployment in Kubernetes Clusters.</div>
                        </div>
                      </span>
                      <br />
                    </div>
                  </div>
                  <hr></hr>
  
                  {/* Feature below will provide seperate buttons for github and docker links to project */}
                  {/* <div className="project-info">
                    <div className="project-view">
                      <h6>See more on this project.</h6>
                    </div>
                    <div className="project-links">
                      <a href='https://github.com/Florence-InLineOfSight/'>
                        <i class="fa fa-github fa-2x"></i>
                      </a>
                      <a href='https://hub.docker.com/repository/docker/florenceomoruyi/php-web-app1/general'>
                        <img src={dockerIcon} alt="no internet connection"></img>
                      </a>
                    </div>
                  </div> */}
                </div>
                
                <div className="project">
                  <span className="project-title">
                    <h5>CI/CD Pipeline For <u>PHP WebApp</u> Deployment.</h5>
                    <h6>(Click image to go to project)</h6>
                  </span>
                  <div className="project-img">
                    <a href="https://www.inlineofsight.net/">
                      <img
                        src={PhpWebApp}
                        alt="Failed to load"
                      />
                    </a>
                  </div>
                  <div className="project-details">
                    <div className="project-description">
                    <div className="project-description-h6">
                        Software Configuration management
                        </div>
                    <br />
                    <div className="project-description-text"></div>
                      <div className="text-styling-1">
                      <div>&emsp;- &ensp; &ensp;</div>
                      <div className="letter-spacing">Automate CI & CD pipeline using Ansible, Nexus, Sonarqube, Maven, Jenkins
                        Terraform and GIT.</div>
                      </div>
                    
                    <br />
                    <span className="project-description-text">

                    <div className="text-styling-2">
                      <div>&emsp;- &ensp; &ensp;</div>
                      <div>Automating AWS cloud deployments using Shell script, Jenkins. Writing inventory and manifest
                      <br />
                      files, and ansible playbooks. Containerized deployment in Kubernetes Clusters.</div>
                      </div>
                    </span>
                    <br />
                    </div>
                  </div>
  
                  {/* Feature below will provide seperate buttons for github and docker links to project */}
                  {/* <div className="project-info">
                    <div className="project-view">
                      <h6>See more on this project.</h6>
                    </div>
                    <div className="project-links">
                      <a href='https://github.com/Florence-InLineOfSight/'>
                        <i class="fa fa-github fa-2x"></i>
                      </a>
                      <a href='https://hub.docker.com/repository/docker/florenceomoruyi/php-web-app1/general'>
                        <img src={dockerIcon} alt="no internet connection"></img>
                      </a>
                    </div>
                  </div> */}
  
                </div>
              </div>   
          </div>
        </div>
      );
  }
